import { TFunction } from "i18next";
import { MUIDataTableColumn } from "mui-datatables";
import { getCountryName } from "../../shared/technical/i18n/countries";

export function companiesTableColumns(t: TFunction, language: string, smallScreens: boolean): MUIDataTableColumn[] {
  return [
    { name: "id", label: t("Company.id"), options: { filter: false, display: !smallScreens } },
    { name: "name", label: t("Company.name"), options: { filter: false } },
    { name: "city", label: t("Company.city"), options: { filter: false } },
    { name: "customerNumber", label: t("Company.customerNumber"), options: { filter: false } },
    {
      name: "countryIsoCode", label: t("Company.country"), options: {
        customBodyRender: (country) => {
          return getCountryName(country, language);
        },
        filter: false
      }
    },
    { name: "street", label: t("Company.street"), options: { filter: false } },
    { name: "postalCode", label: t("Company.postalCode"), options: { filter: false } },
  ];
}
